import { toastError } from './toast/toast.js';

const getCurrentLocation = (store) => new Promise((resolve, reject) => {
    var _a, _b;
    const currentLocation = (_b = (_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.current;
    if (currentLocation) {
        resolve(currentLocation);
        return;
    }
    navigator.geolocation.getCurrentPosition((location) => resolve({ lat: location.coords.latitude, lng: location.coords.longitude }), (error) => {
        if (error.code === 1) {
            toastError('Error getting your location. Please check your settings', { duration: 2400 });
        }
        reject(error);
    }, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    });
});

export { getCurrentLocation };
